// =====================================================================
// AttachmentThumb (Quadros PRO / S60) — renderiza um anexo de IMAGEM com auth.
// O endpoint de download exige Bearer (header axios) → um <img src> direto daria
// 401. Aqui busca o blob autenticado → object URL same-origin → <img>.
// Cache de SESSÃO (Map por attachmentId) pra não re-baixar a cada refetch do board.
// =====================================================================
import React, { useState, useEffect } from "react";
import api from "../../services/api";

const cache = new Map(); // attachmentId -> objectURL (vive a sessão)

const AttachmentThumb = ({ attachmentId, alt, style, className, onClick, title }) => {
  const [src, setSrc] = useState(() => cache.get(String(attachmentId)) || "");

  useEffect(() => {
    if (!attachmentId) return undefined;
    const key = String(attachmentId);
    if (cache.has(key)) { setSrc(cache.get(key)); return undefined; }
    let active = true;
    (async () => {
      try {
        const resp = await api.get(`/board-attachments/${attachmentId}/download`, { responseType: "blob" });
        const url = window.URL.createObjectURL(resp.data);
        cache.set(key, url);
        if (active) setSrc(url);
      } catch { /* silencioso */ }
    })();
    return () => { active = false; };
  }, [attachmentId]);

  if (!src) return null;
  return <img src={src} alt={alt || ""} style={style} className={className} onClick={onClick} title={title} />;
};

export default AttachmentThumb;
